export default __webpack_public_path__ + "media/images/dashboard/deal-78f7f19a76b13a03aad7f6d7aad99b9e.svg";